import { z } from 'zod';

/**
 * Whether the driver has taken a dispatched trip (gitaumoses4/chukua#70). Never stored: derived from the trip's status and its `accepted` /
 * `declined` events, by the API's `tripAcceptance` and the phone's copy of the same rule.
 */
export const TRIP_ACCEPTANCES = ['pending', 'accepted', 'declined'] as const;
export type TripAcceptance = (typeof TRIP_ACCEPTANCES)[number];

export const MAX_DECLINE_REASON_LENGTH = 500;

/** The payload of a `declined` event: why the driver refused. A trimmed, non-empty reason is required. */
export const tripDeclinedPayloadSchema = z.object({ reason: z.string().trim().min(1, 'Say why you are declining the trip').max(MAX_DECLINE_REASON_LENGTH) });
export type TripDeclinedPayload = z.infer<typeof tripDeclinedPayloadSchema>;
